const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please try again.';
const NETWORK_ERROR_MESSAGE = 'Unable to connect to the internet. Please check your connection and try again.';
const NOT_CONFIGURED_MESSAGE = 'This option is not configured yet. Please contact the restaurant.';
const PAYMENT_UNAVAILABLE_MESSAGE = 'Online payment is currently unavailable. Please choose another payment method or contact the restaurant.';

function hasHtml(content: string): boolean {
  return /<\/?[a-z][\s\S]*>/i.test(content);
}

function toReadableMessage(input: any): string {
  if (typeof input === 'string') {
    return input;
  }

  if (!input) {
    return '';
  }

  if (typeof input === 'object') {
    if (typeof input.displayMessage === 'string') {
      return input.displayMessage;
    }
    if (typeof input.message === 'string') {
      return input.message;
    }
    if (typeof input.error === 'string') {
      return input.error;
    }
    if (input.error && typeof input.error.displayMessage === 'string') {
      return input.error.displayMessage;
    }
    if (input.error && typeof input.error.message === 'string') {
      return input.error.message;
    }
    if (typeof input.status === 'number' && input.status === 0) {
      return NETWORK_ERROR_MESSAGE;
    }
  }

  return String(input);
}

export function normalizeUiMessage(input: any, fallback: string = DEFAULT_ERROR_MESSAGE): string {
  let message = toReadableMessage(input);
  message = (message || '').replace(/\s+/g, ' ').trim();

  if (!message || message === 'undefined' || message === 'null' || message === '[object Object]') {
    return fallback;
  }

  if (hasHtml(message)) {
    return message;
  }

  const lowerMessage = message.toLowerCase();

  if (
    lowerMessage.includes('unable to connect to internet') ||
    lowerMessage.includes('unable to connect to the internet') ||
    lowerMessage.includes('network connectivity') ||
    lowerMessage.includes('failed to fetch') ||
    lowerMessage.includes('http failure response') ||
    lowerMessage.includes('error code: 0')
  ) {
    return NETWORK_ERROR_MESSAGE;
  }

  if (lowerMessage.includes('no result found')) {
    return NOT_CONFIGURED_MESSAGE;
  }

  if (
    lowerMessage.includes('payment is not configured') ||
    lowerMessage.includes('payment method is not configured') ||
    lowerMessage.includes('stripe payment method unavailable') ||
    lowerMessage.includes('payment gateway unavailable')
  ) {
    return PAYMENT_UNAVAILABLE_MESSAGE;
  }

  message = message
    .replace(/^error\s*:\s*/i, '')
    .replace(/^error code\s*:\s*\d+\s*message\s*:\s*/i, '')
    .replace(/^http failure response for .*?:\s*/i, '')
    .trim();

  if (!message) {
    return fallback;
  }

  message = message.charAt(0).toUpperCase() + message.slice(1);

  if (!/[.!?]$/.test(message)) {
    message += '.';
  }

  return message;
}
